import { atomWithReset } from 'jotai/utils';

import { DeleteMedicationFollowupMessageModal } from './types';

export const deleteMedicationFollowupMessageModalState =
  atomWithReset<DeleteMedicationFollowupMessageModal>({
    isOpen: false,
    medicationFollowupMessageId: null,
  });
